<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-tabView (onChange)="abrirAcordeon($event)" [(activeIndex)]="activeIndex">
      <p-tabPanel [selected]="tabSeleccionado === 'EDITAR'" header="{{ 'PAGADURIA.LBL_GENERALPAGADURIA' | translate }}">
        <form #fr="ngForm" [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
          <div class="grid form-group">
            <div class="col-12 md:col-2 lg:col-2" *ngIf="pagaduria">
              <div class="div-form">
                <label>{{ 'PAGADURIA.LBL_CODIGO' | translate }}</label>
                <label class="falso-combo-texto" style="background: #b7b3b36e">{{f.codigo.value}}</label>
              </div>
            </div>
            <div [ngClass]="{ 'col-12 md:col-2 lg:col-2': pagaduria, 'col-12 md:col-4 lg:col-4': !pagaduria }">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_NIT' | translate }}</label>
                <input name="NIT" id="NIT" type="text" pInputText (blur)="validarTercero() "
                       (focus)="inhInput()" [disabled]="this.inhInput()? false : true"
                       [maxLength]="13"
                       formControlName="nit" name="NIT" autocomplete="false" *ngIf="!pagaduria"
                       appTexto document-type [sinLetras]="true" [sinCaracteres]="true" [sinComa]="true"
                       [sinPunto]="true" [sinEspacio]="true" required="true">
                <label *ngIf="pagaduria" class="falso-combo-texto" style="background: #b7b3b36e">{{f.nit.value}}
                </label>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nit.invalid">
                  {{ 'PAGADURIA.LBL_NIT' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_DV' | translate }}</label>
                <input class="falso-combo-texto" disabled="true" style="background: #b7b3b36e" formControlName="digitoVerificacion" name="dv" required="true">

                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.digitoVerificacion.invalid">
                  {{ 'PAGADURIA.LBL_DV' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_RAZONSOCIAL' | translate }}</label>
                <input [maxLength]="128" pInputText appTexto formControlName="razonSocial"
                       name="razonSocial" id="idRazonSocial" required="true" type="text">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.razonSocial.invalid">
                  {{ 'PAGADURIA.LBL_RAZONSOCIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_CAMSOCIEDAD' | translate }}</label>
                <p-dropdown disableTab  id="idTipoSociedad" name="nomidTipoSociedad"
                            formControlName="tipoSociedad"
                            [options]="lisTiposSociedades"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                            required="true"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tipoSociedad.invalid">
                  {{ 'PAGADURIA.LBL_CAMSOCIEDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_SECTOR' | translate }}</label>
                <p-dropdown disableTab  id="idTipoSector" name="nomidTipoSector"
                            formControlName="idSector"
                            [options]="lisTiposSectores"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                            required="true"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idSector.invalid">
                  {{ 'PAGADURIA.LBL_SECTOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4 lg:col-4">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_DIRECCION' | translate }}</label>
                <label class="falso-combo-texto" (click)="agregarDirrecion(tipoDireccion.EMPRESA, locEmpleado)"
                       id="direccionEmpresa" name="direccionEmpresa"
                        >{{f.direccionEmpresa.value}}</label>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.direccionEmpresa.invalid">
                  {{ 'PAGADURIA.LBL_DIRECCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_DEPARTAMENTO' | translate }}</label>
                <label style="background: #b7b3b36e" required="true" class="falso-combo-texto">{{f.departamento.value}}</label>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.departamento.invalid">
                  {{ 'PAGADURIA.LBL_DEPARTAMENTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_CIUDAD' | translate }}</label>
                <label style="background: #b7b3b36e" required="true" class="falso-combo-texto">{{f.ciudad.value}}</label>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.ciudad.invalid">
                  {{ 'PAGADURIA.LBL_CIUDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_TIPTELEFONOUNO' | translate }}</label>
                <p-dropdown disableTab  id="idTipoTelefonoUno" name="tipoTelefonoUno"
                            formControlName="idTipoTelefono1"
                            (onChange)="verificarTipoTelefon1()"
                            [options]="lisTiposTelefonos"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            optionValue="value"
                            optionLabel="label"
                            required="true"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoTelefono1.invalid">
                  {{ 'PAGADURIA.LBL_TIPTELEFONOUNO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_TELEFONOCONTACUNO' | translate }}</label>
                <input type="text" pInputText id="numeroTelefono" name="nomTelefono"
                       autocomplete="off"
                       formControlName="telefonoContacto1" numero-telefono-reactive
                       [maxLength]="codTipoDato === tiposTelefonosEnum.FIJO ? 12 : 14"
                       [telFijo]="codTipoDato === tiposTelefonosEnum.FIJO">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.telefonoContacto1.invalid">
                  {{ 'PAGADURIA.LBL_TELEFONOCONTACUNO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_CORREOELECTRONICO' | translate }}</label>
                <input type="text" pInputText id="correoElectronico"
                       name="nomCorreoElectronico" autocomplete="new-password" formControlName="correoElectronico"
                       capitalize-reactive
                       [appEmailSuggest]="true" [dominios]="dominios.dominios"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.correoElectronico.invalid">
                  {{ 'PAGADURIA.LBL_CORREOELECTRONICO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_CARGOCONTACTO' | translate }}</label>
                <input [maxLength]="100" pInputText appTexto formControlName="cargoContacto"
                       name="cargoContacto" id="idCargoContacto" required="true" type="text">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.cargoContacto.invalid">
                  {{ 'PAGADURIA.LBL_CARGOCONTACTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_NOMBRECONTACTO' | translate }}</label>
                <input [maxLength]="100" pInputText appTexto formControlName="nombreContacto"
                       name="nombreContacto" id="idnombreContacto" required="true" type="text">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombreContacto.invalid">
                  {{ 'PAGADURIA.LBL_NOMBRECONTACTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>{{ 'PAGADURIA.LBL_TIPTELEFONODOS' | translate }}</label>
                <p-dropdown disableTab  id="idTipoTelefonoDos" name="nomidTipoTelefonoDos" (onChange)="verificarTipoTelefono2()"
                            formControlName="idTipoTelefono2" [options]="lisTiposTelefonos"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"

                ></p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>{{ 'PAGADURIA.LBL_TELEFONOCONTACDOS' | translate }}</label>
                <input type="text" pInputText id="numeroTelefono2" name="nomTelefono2"
                       autocomplete="off"
                       formControlName="telefonoContacto2" numero-telefono-reactive
                       [maxLength]="codTipoDato === tiposTelefonosEnum.FIJO ? 12 : 14"
                       [telFijo]="codTipoDato === tiposTelefonosEnum.FIJO">
              </div>
            </div>
            <div class="col-12 md:col-2 lg:col-2 flex align-items-center">
              <div class="div-form pt-3">
                <div>
                <p-checkbox id="indicadorFondoPension"
                            name="nomIndicadorFondoPension"
                            formControlName="indicadorFondoPension"
                            binary="true">
                </p-checkbox>
                <label class="pl-2">{{ 'PAGADURIA.LBL_FONDOPENSION' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_ESTADO' | translate }}</label>
                <p-dropdown disableTab  id="idEstado" name="estado"
                            formControlName="idEstadoFuncionalidad" [options]="lisEstadosFuncionalidades"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                             required="true"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstadoFuncionalidad.invalid">
                  {{ 'PAGADURIA.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_CODIGOSHIVAM' | translate }}</label>
                <input type="text" pInputText id="codigoShivam"
                       name="nomCodigoShivam"
                       autocomplete="off"
                       formControlName="codigoShivam"
                       maxlength="10"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoShivam.invalid">
                  {{ 'PAGADURIA.LBL_CODIGOSHIVAM' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'PAGADURIA.LBL_ENTIDAD' | translate }}</label>
                <p-dropdown disableTab  id="idEntidad" name="entidad"
                            formControlName="idEntidad" [options]="listasEmpresasAleatorias"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                            required="true"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEntidad.invalid">
                  {{ 'PAGADURIA.LBL_ENTIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div  *ngIf="!guardando">
                <a *ngIf="!pagaduria" (click)="cancelar((fr.dirty === true))" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <a *ngIf="pagaduria" (click)="cancelarAct((fr.dirty === true))" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-tabPanel>
      <p-tabPanel [selected]="tabSeleccionado === 'CONDICIONES'" header="{{ 'PAGADURIA.LBL_CONDICIONES' | translate }}"  [disabled]="!pagaduria">
                  <app-pagaduria-condiciones-listado [pagaduria]="pagaduria" *ngIf="pagaduria && pagaduria.idPagaduria && tabSeleccionado === 'CONDICIONES'"></app-pagaduria-condiciones-listado>
      </p-tabPanel>
    </p-tabView>
    <div style="text-align: center;">
      <div class="form-group col-12" *ngIf="verAprobacionCondicion">
        <div>
          <button label="{{'PAGADURIA.BTN_DENEGARCONFIGURACION' | translate }}" style="background: red; margin: 20px"
                  type="button" (click)="denegarConfiguracion()"
                  pButton></button>
          <button label="{{'PAGADURIA.BTN_APROBARCONFIGURACION' | translate }}" style="background: #009638; margin: 20px"
                  type="button" (click)="aprobarConfiguracion()"
                  pButton></button>
        </div>
      </div>
      <div class="form-group col-12">
        <div>
<!--          EL BOTON REGRESAR SE DEBE MOSTRAR AL MOMENTO DE GUARDAR LA PAGADURIA -- CAMBIAR NGIF-->
          <button *ngIf="pagaduria" label="{{'BTN_REGRESAR' | translate }}" style="background: #009638"
                  type="button" (click)="regresar((fr.dirty === true))"
                  pButton></button>
        </div>
      </div>
    </div>
  </div>
  </div>

  <p-confirmDialog #cd>
    <ng-template pTemplate="footer">
      <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
      <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
    </ng-template>
  </p-confirmDialog>

</div>

<p-dialog header="{{ 'PAGADURIA.BTN_DENEGARCONFIGURACION' | translate}}" [(visible)]="mosModalDenegacion" [contentStyle]="{'width':'600px'}" modal="true" *ngIf="mosModalDenegacion">
  <div class="grid">
    <div class="col-12 lg:col-12 md:col-12">
      {{descripcion}}
    </div>
  </div>
  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="col-12">
          <div class="div-form">
            <label><strong>*{{ 'PAGADURIA.LBL_OBSERVACION' | translate}} :</strong></label>
            <textarea type="text" pInputText id="campoObservacion"
                   name="campoObservacion" [maxlength]="500"
                   autocomplete="off" capitalize-reactive
                   [(ngModel)]="campoObservacion" required></textarea>
            <div class="p-message p-messages-error p-corner-all" *ngIf="campoObservacionSubmitted && !campoObservacion">
              {{ 'PAGADURIA.LBL_OBSERVACION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
              pButton (click)="cerrarModalDenegacion()" style="background: red; margin: 20px"></button>
      <button icon="fa fa-close" label="{{ 'BTN_GUARDAR' | translate }}" type="button"
              pButton (click)="guardarObservacion()"></button>
    </div>
  </div>
</p-dialog>
